import { LockIcon } from './LockIcon'

interface ScoreValueProps {
  numerator?: number | null
  denominator: number
  isLock: boolean
  lockColor: string
  textColor: string
  isInsideLeaf?: boolean
}

type ScoreSpeechKind = 'rank' | 'score'

/** Spoken form of N/M ranks and scores (See Why_B06). "out of" avoids matching list "N of M". */
export const formatScoreOfTotalSpeech = (
  numerator: number | null | undefined,
  denominator: number,
  isLock: boolean,
  speechKind: ScoreSpeechKind = 'score'
): string => {
  if (isLock || numerator == null || numerator === undefined) {
    if (denominator > 0) {
      return speechKind === 'rank' ? `Rank locked out of ${denominator}` : `Locked out of ${denominator}`
    }
    return speechKind === 'rank' ? 'Rank locked' : 'Locked'
  }
  if (speechKind === 'rank') {
    return denominator > 0 ? `Rank ${numerator} out of ${denominator}` : `Rank ${numerator}`
  }
  return denominator > 0 ? `Score ${numerator} out of ${denominator}` : `Score ${numerator}`
}

export const ScoreValue = ({
  numerator,
  denominator,
  isLock,
  lockColor,
  textColor,
  isInsideLeaf = false
}: ScoreValueProps) => {
  return (
    <div style={{ color: textColor }} aria-hidden='true'>
      <div aria-hidden='true'>
        {isLock || !numerator ? (
          <div className={`flex items-center ${isInsideLeaf ? 'mt-[1px]' : '-mt-[2px]'}`}>
            <div className={`${isInsideLeaf ? 'ml-[3px] mt-[1px]' : 'mt-[1px]'}`}>
              <LockIcon fill={lockColor} />
            </div>
            {denominator > 0 ? (
              <span className='text-[18px] ml-[2px] font-[500]'>/{denominator}</span>
            ) : null}
          </div>
        ) : (
          <div className={`text-[18px] font-[500] ${isInsideLeaf ? 'mt-[1px]' : '-mt-[2px]'}`}>
            {numerator}
            {denominator > 0 ? <span className='font-[500]'>/{denominator}</span> : null}
          </div>
        )}
      </div>
    </div>
  )
}
